const formatter = new Intl.NumberFormat("ja-JP", {
  style: "currency",
  currency: "JPY",
  currencyDisplay: "name",
});

export default function Price({ value }: { value: number }) {
  return <span>{formatter.format(value)}</span>;
}
